// @ramonak/react-progress-bar is CommonJS with an `__esModule`-style `default` export, which not
// every module loader unwraps (the dev-server dependency optimizer serves the raw exports object).
// Bare imports of the package are aliased here; the deep import below bypasses that alias...
import ProgressBarModule from "@ramonak/react-progress-bar/dist/index.js";

const unwrapped: unknown = (ProgressBarModule as { default?: unknown })?.default ?? ProgressBarModule;

export default unwrapped as typeof import("@ramonak/react-progress-bar").default;
